// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__gEfTF","title":"InfoRow_title__YEixq"};